// import Vue from 'vue'
// import Buy from './Buy'

// Vue.config.productionTip = false

// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   components: { Buy },
//   template: '<Buy/>'
// })
window.location.replace('https://reading.baicizhan.com/h5/article.html?id=341&buy_from=mint_gzh_mxyss#/')



// WEBPACK FOOTER //
// ./src/buyMain.js